import { workspaceStore } from "./workspaceStore";

export function requireWorkspace() {
  const ws = workspaceStore.getSelected();
  if (!ws) {
    throw new Error("No workspace selected. Go to Workspaces and select one.");
  }
  return ws;
}
